import { normalize } from 'normalizr';
import { ActionTree } from 'vuex';
import { reply } from '@descomplica/dex-store/lib/normalizr_schema';
import { ReplyState } from './state';
import RootState from '@/store/root_state';
import { ExercisesEvaluationService } from '@/services/undergrad/pegasus-pepe-legal/exercises-evaluation.service';
import { ErrorHandler } from '@/helpers/errorHandler';
import i18n from '@/i18n';
import { Exercise } from '@/models/undergrad/undegrad-lesson.model';
import { ReplyType } from '@/models/undergrad/services/lessons-reader.model';

const actions: ActionTree<ReplyState, RootState> = {
  async CREATE_OBJECTIVE_THINK_AND_ANSWER_REPLY(
    _,
    payload: {
      exercise: Exercise;
      userId: number;
      assertionId: number;
      answer: number;
    },
  ) {
    try {
      const { exercise, userId, assertionId, answer } = payload;
      const replyCreated: any = await new ExercisesEvaluationService().sendObjectiveThinkAndAnswer({
        assertionId,
        dexExerciseId: exercise.dexExerciseId,
        dexUserId: userId,
        answer,
      });

      const updatedReplies: ReplyType = {
        id: replyCreated.id,
        alternativeId: replyCreated.alternativeId,
      };

      exercise.replies?.push(updatedReplies);

      return { success: true };
    } catch (error) {
      ErrorHandler.showErrorMessage({
        customMessage: i18n.t('defaultErrorMessage').toString(),
        error,
      });

      return { success: false };
    }
  },
  async CREATE_REVIEW_LIST_REPLY({ commit }, payload): Promise<{ success: boolean }> {
    const { questionId, userId, assertionId, answer } = payload;

    try {
      const replyCreated = await new ExercisesEvaluationService().sendReviewListAnswer({
        assertionId,
        dexExerciseId: questionId,
        dexUserId: userId,
        answer,
      });

      const replyToNormalize = {
        reply: { ...replyCreated, assertionId: replyCreated.alternativeId },
      };

      const normalizedResponse = normalize(replyToNormalize, { reply });
      commit('SET_REPLIES', normalizedResponse.entities);

      // Solution contents
      commit('SET_SOLUTIONS', normalizedResponse.entities);
      commit('SET_CONTENTS', normalizedResponse.entities);
      commit('SET_TEXTS', normalizedResponse.entities);
      commit('SET_IMAGES', normalizedResponse.entities);
      commit('SET_VIDEOS', normalizedResponse.entities);
      commit('SET_USERS', normalizedResponse.entities);

      return { success: true };
    } catch (error) {
      ErrorHandler.showErrorMessage({
        customMessage: i18n.t('defaultErrorMessage').toString(),
        error,
      });
      return { success: false };
    }
  },
};

export default actions;
